import script from "./ProblemSolutionSection.vue?vue&type=script&setup=true&lang=js"
export * from "./ProblemSolutionSection.vue?vue&type=script&setup=true&lang=js"

import "./ProblemSolutionSection.vue?vue&type=style&index=0&id=790e5682&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-790e5682"]])

export default __exports__